import { Modal, Card } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import Button from "@mui/material/Button";
import "../css/Override.scss";
import "./NewGameModal.scss";

type ItemProp = {
  selected: boolean;
  goalname: string;
  className: any;
  onClickHandler: (idx: number) => void;
};

const GoalItem = ({ selected, goalname, className, onClickHandler }: ItemProp) => {
  const goalitem_ref = useRef(null);
  const [visibility, setVisibility] = useState(false);
  if (selected !== visibility) setVisibility(selected);
  useEffect(() => {
    if (visibility) goalitem_ref.current.classList.remove("hide");
    else goalitem_ref.current.classList.add("hide");
  }, [visibility]);

  return (
    <div className="goal-item-wrap">
      <div className={`goal-size goal-${className}`}>
        <div className="selected-goal hide" ref={goalitem_ref} />
      </div>
      <div className="goal-item-name">{goalname}</div>
    </div>
  );
};

export default GoalItem;
